import { HttpParams } from '@angular/common/http';

type QueryKey<T> = Extract<keyof T, string>;

export abstract class PageQueriesBaseModel {
  getParams(): HttpParams {
    let params = new HttpParams();
    const keys = Object.keys(this) as QueryKey<this>[];
    const toProcess = keys.filter(prop => {
      return typeof this[prop] !== 'function';
    });

    toProcess.forEach(prop => {
      params = params.set(prop, this[prop].toString());
    });

    return params;
  }
}
